import Lottie from 'lottie-react';

import { constants } from 'appConstants';

const PersonalityTraitsLoading = () => {
  return (
    <div>
      <Lottie
        animationData={constants.animations.personalityTraitsLoading}
        loop
        autoplay
        style={{ height: 200, width: 200 }}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />
    </div>
  );
};

export default PersonalityTraitsLoading;
